export { ShieldExclamation as default } from './ShieldExclamation';
